$(document).ready(function () {

    var kbwConreq = (function () {

        var $window = $(window);

        let ajaxEndpoint = '/kbw/conreq/';

        var init = function () {

            addEventListeners();
            return;
        };

        var addEventListeners = function () {

            $('.js-conreq-toggle').on('click', handleToggle);
            $('.js-conreq-submit').on('click', handleSubmit);
            $('.js-conreq-toggle-status').on('click', handleToggleStatus);

        }

        var handleToggle = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);
            let $container = $target.parents('.js-conreq');

            $container.find('.js-conreq-togglecontainer').slideToggle();
        }

        var handleSubmit = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);
            let $container = $target.parents('.js-conreq');
            let $form = $container.find('.js-conreq-form');

            let page = $form.find('input[name="page"]').val();
            let subject  = $form.find('select[name="subject"]').val();

            let url = ajaxEndpoint + 'submit';
            let data = {
                page: page,
                subject: subject
            }

            ajaxPost(url, data, $container, $target, postSubmit);
        }

        var postSubmit = function ($container, $target, data) {
            $container.find('.js-conreq-togglecontainer').slideToggle();

            if (data['success'] === '1') {
                $container.prepend('<div class="ce_text notice notice--hint"><p>Ihre Beratungsanfrage wurde übermittelt.</p></div>')
            } else {
                $container.prepend('<div class="ce_text notice notice--warning"><p>Ihre Beratungsanfrage konnte nicht übermittelt werden.</p></div>')
            }
        }

        var handleToggleStatus = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);
            let $container = $target.parents('.js-conreq-row');
            let consultingId = $target.data('conreq-id');

            let url = ajaxEndpoint + 'status';
            let data = {
                conid: consultingId
            }

            ajaxPost(url, data, $container, $target, postToggleStatus);
        }

        var postToggleStatus = function ($container, $target, data) {
            if (data['status'] === '') {
                $container.removeClass('active')
                $container.find('.js-lift-status').html('bearbeitet');
                $target.html('als offen markieren');
            } else {
                $container.addClass('active')
                $container.find('.js-lift-status').html('offen');
                $target.html('als bearbeitet markieren');
            }
        }

        var ajaxPost = function (url, data, $container, $target, successCallback) {
            $.ajax({
                method: "POST",
                url: url,
                data: data,
                dataType: "json"

            }).done(function (returnData) {
                console.log(returnData);
                // if (returnData['success']) {
                //     console.log(returnData['numDocs']);
                // }

                if (returnData['success'] === '1') {
                    successCallback($container, $target, returnData);
                } else {
                    alert(returnData['errMessage'])
                }

            }).fail(function (jqXHR, textStatus) {
                console.log(textStatus);
            });
        }


        return {
            init: init
        }

    })();

    kbwConreq.init();

});



